import {
    Button,
    Container,
    Divider,
    Icon,
    Paper,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorDetail } from "../../api/config";
import { UserDto, UserService, UserStatus } from "../../api/psc.ts";
import ErrorDetailParser from "../../components/ErrorDetailParser";
import PageHeader from "../../components/PageHeader";
import Spinner from "../../components/Spinner";
import UserListItem from "./UserListItem";

export default function ListUsers() {
    const navigate = useNavigate();

    const [users, setUsers] = useState<UserDto[] | null>(null);
    const [error, setError] = useState<ErrorDetail | null>(null);
    const [status, setStatus] = useState<UserStatus | null>(UserStatus.ACTIVE);
    const [term, setTerm] = useState<string | null>(null);

    useEffect(() => {
        UserService.listUsers()
            .then((r) => {
                setUsers(
                    r
                        .filter((i) => status === null || i.status === status)
                        .filter(
                            (i) =>
                                term === null ||
                                term === "" ||
                                i.firstName.includes(term) ||
                                i.lastName.includes(term) ||
                                i.username.includes(term)
                        )
                );
            })
            .catch((e: ErrorDetail) => {
                setError(e);
                setUsers([]);
            });
    }, [status, term]);

    const goToCreateUser = () => {
        navigate("/user/create");
    };

    if (users === null) {
        return <Spinner />;
    }

    function handleChange(
        _event: React.MouseEvent<HTMLElement>,
        value: UserStatus | null
    ): void {
        setStatus(value);
    }

    const handleTermChange = (event: ChangeEvent<HTMLInputElement>) => {
        setTerm(event.target.value);
    };

    return (
        <Container maxWidth="sm">
            <PageHeader
                title="لیست کاربران"
                action={
                    <Button
                        variant="contained"
                        startIcon={<Icon>add</Icon>}
                        onClick={goToCreateUser}
                    >
                        افزودن کاربر
                    </Button>
                }
            />

            {error && <ErrorDetailParser error={error} />}

            <ToggleButtonGroup
                fullWidth
                color="primary"
                value={status}
                exclusive
                size="small"
                onChange={handleChange}
                sx={{ mb: 2 }}
            >
                <ToggleButton value={UserStatus.ACTIVE}>فعال</ToggleButton>
                <ToggleButton value={UserStatus.DE_ACTIVE}>
                    غیر فعال
                </ToggleButton>
                <ToggleButton value={UserStatus.SOFT_DELETED}>
                    حذف شده
                </ToggleButton>
                <ToggleButton value={null}>همه</ToggleButton>
            </ToggleButtonGroup>

            <TextField
                fullWidth
                size="small"
                label="جستجو"
                value={term}
                onChange={handleTermChange}
                variant="outlined"
                sx={{ mb: 2 }}
            />

            {users.length > 0 && (
                <Paper sx={{ p: 2 }}>
                    <Stack spacing={1.5} divider={<Divider />}>
                        {users?.map((u) => {
                            return <UserListItem key={u.id} user={u} />;
                        })}
                    </Stack>
                </Paper>
            )}
        </Container>
    );
}
